<template>
  <div
    class="filter"
    v-if="!supplierID"
  >
    <p-vue-input-text
      type="text"
      class="phone-number search"
      v-model="search"
      :placeholder="__('search')"
    />
  </div>
  <div
    class="suppliers-list"
    :class="{ 'add-margin': !supplierID, 'one-supplier': supplierID }"
  >
    <local-supplier
      v-for="(supplier, index) of suppliers"
      :key="index"
      :supplier="supplier"
      @showSupplierData="showSupplierData"
      @DeleteSupplier="DeleteSupplier"
    ></local-supplier>
  </div>

  <i-override-dialog
    v-model:visible="showAddModal"
    :style="{
      width: '100%',
      maxWidth: 'calc(100vw - 10px)',
    }"
    :modal="true"
    :dismissableMask="true"
    :title="__('Add') + ' ' + __('Supplier')"
  >
    <local-add-supplier
      :supplier="{}"
      :close="
        () => {
          showAddModal = false;
        }
      "
      @supplierUpdate="supplierUpdate"
    ></local-add-supplier>
  </i-override-dialog>
  <i-plus-button v-if="!supplierIDToShow" @click="showAddModal = true" />
  <p-vue-confirm-popup></p-vue-confirm-popup>
</template>

<script>
import { getWorkerData } from "@/services/service";
import { errorReceived } from "@/services/apointUtil";
import { callProc, apiParam, apiPType } from "@/services/APointAPI";
import { mapState } from "vuex";
import LocalSupplier from "./supplier";
import LocalAddSupplier from "./add-supplier";

export default {
  components: {
    LocalSupplier,
    LocalAddSupplier,
  },
  props: {
    supplierIDToShow: Number,
  },
  data() {
    return {
      supplierID: this.$route.params.supplierid,
      suppliersList: [],
      search: null,
      showAddModal: false,
    };
  },
  mounted() {
    if (this.supplierIDToShow) this.supplierID = this.supplierIDToShow;
    if (!this.userNum) getWorkerData().then(() => this.getSuppliers());
    else this.getSuppliers();
  },
  methods: {
    getSuppliers() {
      this.$store.dispatch("doLoading", true);
      let procParams = [
        apiParam("UserNum", this.userNum, apiPType.Int),
        apiParam(
          "supplierID",
          this.supplierID ? this.supplierID : null,
          apiPType.Int
        ),
      ];
      callProc("WorkerApp_SupplierList", procParams)
        .then((result) => {
          result = JSON.parse(result);
          this.suppliersList = result.Table;
          this.suppliersList.map((supplier) => {
            supplier.showData = false;
            supplier.Contacts = result.Table1.filter(
              (f) => f.SupplierSubID == supplier.SupplierID
            );
            this.setContactsToSupplier(supplier);
          });
          // console.log(this.suppliers.length);
          if (this.suppliersList.length == 1)
            this.suppliersList[0].showData = true;
          this.$store.dispatch("doLoading", false);
        })
        .catch(() => {
          errorReceived("WorkerApp_SupplierList");
        });
    },
    showSupplierData(supplier) {
      let lastShowData = supplier.showData;
      this.suppliersList.map((s) => {
        s.showData = false;
      });
      supplier.showData = !lastShowData;
    },
    supplierUpdate(supplier) {
      this.setContactsToSupplier(supplier);
      let index = this.suppliersList.findIndex(
        (f) => f.SupplierID == supplier.SupplierID
      );
      if (index != -1) this.suppliersList[index] = supplier;
      else this.suppliersList.push(supplier);
      this.showAddModal = false;
    },
    DeleteSupplier(SupplierID) {
      let index = this.suppliersList.findIndex(
        (f) => f.SupplierID == SupplierID
      );
      this.suppliersList.splice(index, 1);
    },
    setContactsToSupplier(supplier) {
      supplier.Contacts.map((c) => {
        c.IsMain = false;
      });
      let mainConatct = {
        id: -1,
        Address: supplier.address,
        Email: supplier.Email,
        FaxWork: supplier.FaxWork,
        LastName: supplier.LastName,
        Notes: supplier.Notes,
        Position: supplier.Position,
        SupplierSubID: supplier.SupplierID,
        TelMobile: supplier.TelMobile,
        TelWork: supplier.TelWork,
        firstName: supplier.FirstName,
        IsMain: true,
      };
      supplier.Contacts.push(mainConatct);
      supplier.Contacts.sort((a, b) => a.id - b.id);
    },
  },
  computed: {
    ...mapState({
      userNum: (state) => state.api.workerID,
    }),
    suppliers() {
      this.suppliersList.map((s) => {
        if (
          (this.search &&
            this.search != "" &&
            (s.Company?.includes(this.search) ||
              s.FirstName?.includes(this.search) ||
              s.LastName?.includes(this.search) ||
              s.Address?.includes(this.search) ||
              s.Position?.includes(this.search) ||
              s.Notes?.includes(this.search))) ||
          !this.search ||
          this.search == ""
        )
          s.show = true;
        else s.show = false;
      });
      return this.suppliersList.filter((supplier) => supplier.show == true);
    },
  },
};
</script>

<style scoped>
.filter {
  display: flex;
  justify-content: space-between;
  padding: 10px 15px 5px;
  background-color: var(--color-primary);
}

.search {
  flex: 1;

  padding: 0 0 8px 0;

  border-radius: 0;
  border: 1px solid white;
  border-width: 0 0 1px 0;
  background-color: transparent;

  color: white;
  font-size: 16px;
  line-height: 1.28;
  font-style: italic;
  font-weight: normal;
  letter-spacing: 0.51px;
}

.search::placeholder {
  color: white;
  font-size: 16px;
  line-height: 1.28;
  font-style: italic;
  font-weight: normal;
  letter-spacing: 0.51px;
}

.add-margin {
  overflow-y: scroll;
  height: calc(100vh - 155px);
}

.one-supplier:deep(.p-panel .p-panel-content:last-child) {
  border: none;
}
</style>
